// Get Licences
import * as types from "./mutation-types";

export const loadInvoiceStatus = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('admin/get/invoices/status')
            .then(response => {
                commit(types.LOAD_INVOICE_STATUS, response.data)
                resolve(response);
            })
            .catch(error => {
                reject(error.response.data);
            });
    });
};
export const cancelPaidInvoice = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`admin/cancel/invoice/${id}`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const emitCreditNote = ({ commit, dispatch, state }, { invoiceId, products }) => {
    return new Promise((resolve, reject) => {
        const payload = {
            items: products.map(p => ({
                product_id: p.id,
                quantity: p.quantity,
                price: p.price,
                discount: p.discount || 0
            }))
        }
        window.axios.post(`admin/shop/checkout/${invoiceId}/credit-note`, payload).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const normalizeShopInvoice = ({ commit, dispatch, state }, {invoiceId, aib}) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`admin/shop/checkout/${invoiceId}/normalize`, { aib: aib }).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

